import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import BarcodeScanner from './components/barcode/BarcodeScanner.vue';
import router from './router';
import store from './store';

const app = createApp(App);

app.use(router);
app.use(store);
app.component('barcode-scanner', BarcodeScanner);

app.mount('#app');
